import { ContextType } from "./context-type.enum";
import { NextStepDeciderConfig } from "./next-step-decider-config.model";
import { StepConfig } from "./step-config.model";
import { StepType } from "./step-type.enum";

export class ChecklistsStepConfig extends StepConfig {

  checklistIds: number[] = [];

  constructor(id: string, name: string | undefined, path: string, groupId: number | undefined, nextStepDeciderConfig: NextStepDeciderConfig | undefined) {
    super(id, name, path, groupId, ContextType.None);
    this.stepType = StepType.CheckListsStep;
    this.nextStepDeciderConfig = nextStepDeciderConfig;
  }
}
